import { apiFetch } from '@/api/request'
import type { ApiResponse } from '@/types/verification'

export interface MallNotifyItem {
  idx: number
  type: string
  title: string
  body: string
  orderCode: string
  read: boolean
  createdAt: string
}

const API_ORIGIN = (process.env.VUE_APP_API_ORIGIN || '').replace(/\/$/, '')
const BASE = `${API_ORIGIN}/api/mall/notifies`

const fetchOptions: RequestInit = { credentials: 'include' }
const jsonOptions: RequestInit = {
  ...fetchOptions,
  headers: { 'Content-Type': 'application/json' },
}

async function parseJson<T>(response: Response): Promise<ApiResponse<T>> {
  return (await response.json()) as ApiResponse<T>
}

export async function fetchMallNotifies() {
  const response = await apiFetch(BASE, fetchOptions)
  const result = await parseJson<{ items: MallNotifyItem[]; unread: number }>(response)
  if (!result.success || !result.data) {
    throw new Error(result.message || '알림을 불러오지 못했습니다.')
  }
  return result.data
}

export async function markMallNotifiesRead(idx?: number) {
  const response = await apiFetch(`${BASE}/read`, {
    ...jsonOptions,
    method: 'POST',
    body: JSON.stringify(idx ? { idx } : {}),
  })
  const result = await parseJson<{ unread: number }>(response)
  if (!result.success || !result.data) {
    throw new Error(result.message || '알림을 처리하지 못했습니다.')
  }
  return result.data.unread
}
